<template>
	<v-dialog max-width="600px" v-model="dialogModel">
		<v-card>
			<v-card-title class="headline">
				<span v-if="isEdit">{{ $t("message.editProduct") }}</span>
				<span v-else>
					<Address></Address>
					{{ $t("message.addProduct") }}
				</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="productForm" v-model="productForm.valid">
					<v-container grid-list-md pt-0>
						<v-layout row wrap>
							<v-flex md12 xs12 v-show="isCreate">
								<file-pond
									ref="pond"
									label-idle="Arrastra tu imagen o <span class='filepond--label-action'>buscala</span>"
									class-name="my-pond"
									accepted-file-types="image/jpeg, image/png"
									required
								/>
							</v-flex>
							<v-flex xs12>
								<v-select
									v-model="digital"
									:items="digitalFields"
									outlined
								></v-select>
								<v-text-field
									:rules="productForm.linkRules"
									:label="$t('message.productLink')"
									prepend-icon="link"
									required
									v-if="digital == 1"
									v-model="product_url"
								></v-text-field>
							</v-flex>
							<v-flex md12 xs12>
								<v-text-field
									:rules="productForm.nameRules"
									:label="$t('message.name')"
									:hint="productWebUrl"
									prepend-icon="label"
									required
									v-model="productForm.name"
								></v-text-field>
							</v-flex>
						</v-layout>

						<v-layout row wrap>
							<v-flex md12 xs12>
								<v-text-field
									:rules="productForm.descriptionRules"
									:label="$t('message.description')"
									prepend-icon="zmdi-comment-more"
									required
									v-model="productForm.description"
								></v-text-field>
							</v-flex>
						</v-layout>

						<v-layout row wrap>
							<v-flex md12 xs12>
								<v-text-field
									:rules="productForm.priceRules"
									:label="$t('message.price')"
									prepend-icon="zmdi-money"
									type="number"
									min="1"
									pattern="[+]?[0-9]"
									v-model="productForm.price"
									required
								></v-text-field>
							</v-flex>

							<v-flex md12 xs12>
								<v-text-field
									:rules="productForm.quantityRules"
									:label="$t('message.quantity')"
									prepend-icon="zmdi-inbox"
									type="number"
									min="0"
									v-model="productForm.quantity"
								></v-text-field>
							</v-flex>
						</v-layout>

						<v-layout row wrap>
							<v-flex md12 xs12>
								<v-autocomplete
									:rules="productForm.catalogueIdRules"
									item-text="name"
									item-value="id"
									:label="$t('message.catalogue')"
									prepend-icon="zmdi-label"
									:items="catalogues"
									v-model="productForm.catalogueId"
								></v-autocomplete>
							</v-flex>
						</v-layout>
						<v-text-field
							:label="$t('message.index')"
							prepend-icon="zmdi-sort-amount-desc"
							v-model="productForm.index"
							hint="Este valor permite ordenar tus productos de manera ascendente"
							:error-messages="errors.collect('index')"
							data-vv-name="index"
							v-validate="'required|numeric'"
						></v-text-field>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn outline @click="clearForm" color="error" small>{{
					$t("message.close")
				}}</v-btn>
				<v-btn outline @click="onSave" color="primary" small>{{
					$t("message.save")
				}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CATALOGUES } from "../../store/modules/catalogues/actions.type";
import { ADD_IMAGE_PRODUCT } from "../../store/modules/products/actions.type";

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";

// Import styles
import "../../../node_modules/filepond/dist/filepond.min.css";
import "../../../node_modules/filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Create FilePond component
const FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview
);

export default {
	name: "productManage",
	components: {
		FilePond,
	},
	props: {
		dialog: {
			required: false,
			default: false,
		},
		isCreate: {
			required: false,
			default: false,
		},
		isEdit: {
			required: false,
			default: false,
		},
	},
	data() {
		return {
			digitalFields: [
				{ text: "Producto físico", value: 0 },
				{ text: "Producto digital", value: 1 },
				{ text: "Ticket Canjeable", value: 2 },
			],
			digital: 0,
			product_url: null,
			productForm: {
				name: "",
				description: "",
				newImages: [],
				price: 0,
				index: 1,
				catalogueId: 0,
				quantity: 0,
				digital: 0,
				valid: false,
				nameRules: [(v) => !!v || this.$t("message.errorName")],
				descriptionRules: [(v) => !!v || this.$t("message.errorDescription")],
				catalogueIdRules: [(v) => !!v || this.$t("message.errorCatalogue")],
				priceRules: [
					(v) => !!v || this.$t("message.errorPrice"),
					(v) =>
						/^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(v) ||
						"Por favor, ingresa un número válido",
				],
				quantityRules: [
					(v) => /^[0-9]\d*$/.test(v) || "Por favor, ingresa un número válido",
				],
				linkRules: [
					(v) =>
						/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(
							v
						) || "Asegurate de ingresar un url correcto.",
				],
			},
			dialogModel: this.dialog,
		};
	},
	computed: {
		...mapGetters(["catalogues"]),
		productWebUrl() {
			const data = this.$store.getters.store;
			return `${process.env.VUE_APP_WEB_STORE_URL}/${
				data.web_store
			}/${this.toKebabCase(this.productForm.name)}`;
		},
		web_url() {
			return this.toKebabCase(this.productForm.name);
		},
	},
	created() {
		this.$store.dispatch(GET_CATALOGUES);
	},
	methods: {
		closeDialog() {
			this.$emit("close-dialog");
		},
		toKebabCase(str) {
			return (
				str &&
				str
					.match(
						/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
					)
					.map((x) => x.toLowerCase())
					.join("-")
			);
		},
		addNewImage() {
			var { file } = this.$refs.pond.getFile() || {};

			if (file) {
				const reader = new FileReader();

				this.productForm.newImages.push({
					file: file,
					imageUrl: null,
				});

				reader.onload = () => {
					this.productForm.newImages[0].imageUrl = reader.result;
				};

				reader.readAsDataURL(file);
			}
		},
		clearForm() {
			this.closeDialog();

			this.productForm.name = "";
			this.productForm.description = "";
			this.productForm.price = 0;
			this.productForm.catalogueId = 0;
			this.productForm.newImages = [];

			this.$refs.pond.removeFile();
			this.$refs.productForm.reset();
		},
		setValue(product) {
			this.digital = product.digital;
			this.product_url = product.product_url;
			this.productForm.name = product.name;
			this.productForm.description = product.description;
			this.productForm.price = product.price;
			this.productForm.catalogueId = product.catalogue_id;
			this.productForm.quantity = product.quantity;
			this.productForm.index = product.index;
		},
		async onSave() {
			const valid = await this.$refs.productForm.validate();

			if (this.isCreate) {
				this.addNewImage();

				/*if (!this.$refs.pond.getFile()) {
          alert('Por favor, sube una imagen del producto')
        }*/

				if (valid) {
					this.$emit("on-save", {
						name: this.productForm.name,
						description: this.productForm.description,
						price: this.productForm.price,
						quantity: this.productForm.quantity,
						catalogue_id: this.productForm.catalogueId,
						image: this.productForm.newImages,
						digital: this.digital,
						product_url: this.digital == 1 ? this.product_url : null,
						web_url: this.web_url,
					});

					this.closeDialog();
				}
			} else {
				if (valid) {
					this.$emit("on-save", {
						name: this.productForm.name,
						description: this.productForm.description,
						price: this.productForm.price,
						quantity: this.productForm.quantity,
						catalogue_id: this.productForm.catalogueId,
						digital: this.digital,
						product_url: this.digital == 1 ? this.product_url : null,
						web_url: this.web_url,
						index: this.productForm.index,
						//image: this.productForm.newImages
					});

					this.closeDialog();
				}
			}
		},
	},
	watch: {
		dialog(value) {
			this.dialogModel = value;
		},
		dialogModel(value) {
			this.$emit("update:dialog", value);
		},
	},
};
</script>

<style></style>
